// Строка «Kling, скорее всего, откажет» у Kling Motion Control — над промптом, рядом со строкой сцены (тот же жёлтый
// .char-notice: видна без наведения и на телефоне). Предупреждение считает сервер по ролику (hooks/useMotionPrecheck);
// перед запуском его же переспросит окно MotionRiskConfirm.
import { useGenerate } from '../../../context/GenerateContext'

export default function MotionRiskNotice() {
	const { motionRisk } = useGenerate()
	if (!motionRisk) return null
	return (
		<div className="char-notice motion-risk-notice" role="status">
			<span className="char-notice__icon" aria-hidden="true">
				<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
					<path d="M10.3 3.9 1.8 18.6A2 2 0 0 0 3.5 21.6h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
					<path d="M12 9v4.5" />
					<path d="M12 17.5h.01" />
				</svg>
			</span>
			<span className="char-notice__text">{motionRisk.text}</span>
		</div>
	)
}
